import { Button, DatePicker } from 'antd';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const TableFilterDateRange = (props: FilterDropdownProps) => {
  const [value, setValue] = useState([null, null]);

  useEffect(() => {
    if (props.visible) {
      setValue(
        (props.selectedKeys || [null, null]).map(date => {
          if (!date) {
            return date;
          }

          return moment(date);
        })
      );
    }
  }, [props.visible]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Wrapper>
      <DatePicker.RangePicker
        value={
          !!value[0] && !!value[1] ? [moment(value[0]), moment(value[1])] : null
        }
        placeholder={['Start Date', 'End Date']}
        allowClear
        format={'DD MMM YYYY'}
        onChange={newVal => setValue(newVal || [null, null])}
      />
      <div className="btn-container">
        <Button
          type="primary"
          size="small"
          onClick={() => {
            if (!!value[0] && !!value[1]) {
              props.setSelectedKeys(
                value.map(date => date.format('YYYY-MM-DD') + 'T00:00:00+00:00')
              );
            } else {
              props.setSelectedKeys([]);
            }
            props.confirm();
          }}
        >
          Apply
        </Button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 10px;

  .btn-container {
    text-align: right;
    margin-top: 10px;

    .ant-btn-sm {
      font-size: 10px;
    }
  }
`;

export default TableFilterDateRange;
